module.exports = __webpack_public_path__ + "img/Screenshot_2021-10-28-16-04-17-282_com.pinkcoffee.sexbattle.62297ec3.jpg";